import React, { CSSProperties, ReactNode, useRef, useCallback, RefObject } from 'react';
import ReactDOM from 'react-dom';

import { useResizeObserver } from '../../utils/hooks';

const containerStyle = {
    visibility: 'hidden',
    overflow: 'hidden',
    position: 'absolute',
    maxWidth: '100vw',
} as CSSProperties;

const wrapperStyle = {
    display: 'flex',
} as CSSProperties;

type Size = { width: number; height: number };

interface Props {
    children: ReactNode | ReactNode[];
    renderWidth: number;
    nodeRef?: RefObject<HTMLElement>;
    onMeasure?: (size: Size) => void;
}

export const HiddenRender = ({ children, nodeRef, renderWidth, onMeasure }: Props) => {
    const ref = useRef<HTMLDivElement>(null);

    const handleResize = useCallback(() => {
        if (onMeasure && ref.current) {
            const height = ref.current.offsetHeight;
            const width = ref.current.offsetWidth;

            if (width && height) {
                onMeasure({ width, height });
            }
        }
    }, [onMeasure]);

    useResizeObserver(ref, handleResize);

    const wrapperWidth = renderWidth ? `${renderWidth}px` : 'auto';

    const element = (
        <div style={containerStyle}>
            <div style={{ ...wrapperStyle, width: wrapperWidth }}>
                <div ref={ref}>{children}</div>
            </div>
        </div>
    );

    const portal = nodeRef ? nodeRef.current : document.body;

    if (!portal) {
        return null;
    }

    return ReactDOM.createPortal(element, portal);
};
